// @flow

class WebAuthnAbortService {
	controller: AbortController | undefined;

	createNewAbortSignal () {
		// Abort any existing calls to navigator.credentials.create() or navigator.credentials.get()
		if (this.controller) {
			const abortError = new Error(
				'Вы прервали использование FaceID/TouchID, попробуйте позже',
			);
			abortError.name = 'AbortError';
			this.controller.abort(abortError);
		}
  
		const newController = new AbortController();
  
		this.controller = newController;
		return newController.signal;
	}
}

export const webauthnAbortService = new WebAuthnAbortService();
